import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../constants';
import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { fetchCategories } from '../services/categoryService';

import Main_logo_Yellowish from '../assets/images/Main_logo_Yellowish.png';

type Props = {
  links?: { label: string; path: string }[];
  logo?: boolean;
  copyright?: boolean;
};

export const Footer: React.FC<Props> = ({ links, logo, copyright }) => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<any[]>([]);
  const [hoveredCategory, setHoveredCategory] = useState<string | null>(null);
  const muiTheme = useTheme();
  const isSmallScreen = useMediaQuery(muiTheme.breakpoints.down('md'));
  const isMediumScreen = useMediaQuery(
    muiTheme.breakpoints.between('md', 'lg')
  );

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const categoriesData = await fetchCategories();
        setCategories(categoriesData);
      } catch (error) {
        console.error('Failed to load categories:', error);
      }
    };

    loadCategories();
  }, []);

  const renderLogo = (): JSX.Element | null => {
    if (logo) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isSmallScreen ? 'center' : 'flex-start',
            textAlign: isSmallScreen ? 'center' : 'left',
            marginBottom: isSmallScreen ? '20px' : '0',
          }}
        >
          <img
            src={Main_logo_Yellowish}
            alt='Logo'
            style={{
              width: isSmallScreen ? '150px' : '190px',
              height: isSmallScreen ? 'auto' : '110px',
              cursor: 'pointer',
              marginBottom: '10px',
              maxHeight: '110px',
            }}
            onClick={() => navigate('/Home')}
          />
          <Typography
            fontWeight={'bold'}
            fontSize={isSmallScreen ? '14px' : '16px'}
            marginTop={isSmallScreen ? '-30px' : '-40px'}
            color={theme.colors.mainYellow}

          >
            By Rungo Diplomatic Trading Plc
          </Typography>
          <Typography
            width={isSmallScreen ? '100%' : '250px'}
            color={theme.colors.white}
            variant={isSmallScreen ? 'body2' : 'body1'}
            marginTop={isSmallScreen ? '15px' : '20px'}
          >
            Explore, discover, and indulge in the joy of finding those special
            pieces that make you feel truly at home.
          </Typography>
        </div>
      );
    }
    return null;
  };

  const renderCategories = (): JSX.Element | null => {
    if (categories.length > 0) {
      return (
        <nav
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '5px',
            alignItems: isSmallScreen ? 'center' : 'flex-start',
            marginBottom: isSmallScreen ? '20px' : '0',
          }}
        >
          <div
            style={{
              textAlign: isSmallScreen ? 'center' : 'left',
              width: '100%',
            }}
          >
            <Typography
              fontWeight={'bold'}
              fontSize={isSmallScreen ? '18px' : '20px'}
              marginBottom={'10px'}
              color='white'
            >
              Discount Products
            </Typography>
          </div>
          {categories.map((category) => (
            <div
              key={category.id}
              style={{ position: 'relative', width: '100%' }}
              onMouseEnter={() => setHoveredCategory(category.name)}
              onMouseLeave={() => setHoveredCategory(null)}
            >
              <button
                style={{
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                  padding: '8px 10px',
                  fontSize: isSmallScreen ? '13px' : '14px',
                  fontWeight:
                    hoveredCategory === category.name ? 'bold' : 'normal',
                  color:
                    hoveredCategory === category.name
                      ? theme.colors.mainYellow
                      : theme.colors.white,
                  position: 'relative',
                  width: '100%',
                  textAlign: isSmallScreen ? 'center' : 'left',
                }}
                onClick={() => {
                  navigate('/shop', {
                    state: { products: category, title: 'Shop' },
                  });
                }}
              >
                {category.name}
                <span
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: isSmallScreen ? '25%' : 0,
                    height: '2px',
                    backgroundColor: theme.colors.mainYellow,
                    width:
                      hoveredCategory === category.name
                        ? isSmallScreen
                          ? '50%'
                          : '100%'
                        : '0%',
                    transition: 'width 0.3s ease',
                  }}
                />
              </button>
            </div>
          ))}
        </nav>
      );
    }
    return null;
  };

  const renderLinks = (): JSX.Element | null => {
    if (links) {
      return (
        <div
          style={{
            textAlign: isSmallScreen ? 'center' : 'left',
            marginBottom: isSmallScreen ? '20px' : '0',
          }}
        >
          <Typography
            fontWeight={'bold'}
            fontSize={isSmallScreen ? '18px' : '20px'}
            marginBottom={'10px'}
            color={theme.colors.white}
          >
            Contact
          </Typography>
          <Typography
            color={theme.colors.white}
            variant={isSmallScreen ? 'body2' : 'body1'}
          >
            {' +251 980303065 / 34194, UN compound at Nile building , contact@thediplomart.com'
              .split(',')
              .map((text, index) => (
                <React.Fragment key={index}>
                  {text.trim()}
                  <br />
                </React.Fragment>
              ))}
          </Typography>
        </div>
      );
    }
    return null;
  };

  const renderCopyright = (): JSX.Element | null => {
    if (copyright) {
      return (
        <div
          style={{
            fontSize: isSmallScreen ? '12px' : '14px',
            color: theme.colors.white,
            marginTop: '20px',
            width: '100%',
            textAlign: 'center',
            fontWeight: 'bold',
            padding: isSmallScreen ? '0 10px' : '0',
          }}
        >
          © {new Date().getFullYear()} The DiploMart. All rights reserved.
          Design by Ranbes Consultancy
        </div>
      );
    }
    return null;
  };

  return (
    <div
      style={{
        backgroundColor: theme.colors.mainColor,
        textAlign: 'center',
        display: 'block',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 30,
        width: '100%',
      }}
    >
      <footer
        style={{
          padding: isSmallScreen ? '20px 15px' : '20px 30px',
          maxWidth: '1440px',
          margin: '0 auto',
          borderTop: `1px solid ${theme.colors.aliceBlue2}`,
        }}
      >
        <Grid
          container
          spacing={isSmallScreen ? 3 : 4}
          justifyContent='space-around'
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{
              display: 'flex',
              justifyContent: isSmallScreen ? 'center' : 'center',
            }}
          >
            {renderLogo()}
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            style={{
              display: 'flex',
              justifyContent: isSmallScreen ? 'center' : 'center',
            }}
          >
            {renderCategories()}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={4}
            style={{
              display: 'flex',
              justifyContent: isSmallScreen ? 'center' : 'center',
            }}
          >
            {renderLinks()}
          </Grid>
          <Grid item xs={12}>
            {renderCopyright()}
          </Grid>
        </Grid>
      </footer>{' '}
    </div>
  );
};
